import { render, staticRenderFns } from "./FormAddLevel.vue?vue&type=template&id=0c617c3c&scoped=true"
import script from "./FormAddLevel.vue?vue&type=script&lang=js"
export * from "./FormAddLevel.vue?vue&type=script&lang=js"
import style0 from "./FormAddLevel.vue?vue&type=style&index=0&id=0c617c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c617c3c",
  null
  
)

export default component.exports